import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { auth, profileAPI, accountAPI, kycAPI, transactionAPI } from "services";

const universalStore = (set, get) => ({
  accountId: null,
  accounts: null,
  transactionId: null,
  user: null,
  profile: null,
  transactions: null,
  isReminderChanged: false,
  selectedMonth: new Date(),
  txnViewMode: localStorage.getItem('txnView') || 't-view',

  // activeComponent:"edit",
  fetchInitialData: async () => {
    try {
      const [user, accounts, userBasic] = await Promise.all([
        auth.fetchUser(),
        accountAPI.getAccounts(),
        profileAPI.getProfileBasics(),
      ]);
      const savedKhataPreference = userBasic?.preferences?.txnView || localStorage.getItem('txnView') || 't-view';
      //Update Global State
      set({
        user,
        accounts,
        userBasic,
        selectedMonth: new Date(),
        txnViewMode: savedKhataPreference,
      });
    } catch (error) {
      console.error("Failed to fetch initial data", error);
    }
  },

  setTxnViewMode: async (mode) => {
    set({ txnViewMode: mode });
    try {
      localStorage.setItem('txnView', mode);
      const userBasic = await profileAPI.updateUserPreference('txnView', mode);
      if (userBasic) {
        set({ userBasic });
      }
    } catch (error) {
      console.error("Failed to update txn view preference in profile:", error);
    }
  },

  write: (obj) => {
    if (typeof obj === 'function') {
      const result = obj(get()); // Get the current state and pass it to the function
      set(result);
      return;
    }

    //Update Global State
    set(state => ({ ...state, ...obj }));
  },
});

const useUniversalStore = create(
  devtools(universalStore, { name: "Universal Store" })
);

export default useUniversalStore;
